
export const VocabProfileOnboarding = {
    //  Title
    'onboarding_title': ['Nos alegra tenerte', 'We are glad to have you'],
    'onboarding_message': ['Para brindarte la mejor atención posible, necesitamos conocerte un poco mejor.', 
        'To provide you with the best possible care, we need to get to know you a little better.'],
    'confidentiality_legend': ['Toda la informacion recabada es confidencial y esta protegida de acuerdo con nuestras', 
        'All gathered data is confidential and is protected under our'],
    'confidentiality_link': ['politicas de privacidad', 'privacy policies'],
    /*  Step 0 Welcome instructions   */
    'welcome_title': ["¡Creemos tu perfil clínico!", "Let's create your clinical profile!"],
    'welcome_intro': ['Este proceso es sencillo y fundamental para historia clinica.', 
        'This process is simple and essential for your medical record.'],
    'time_label': ["Tiempo estimado:", "Estimated time:"],
    'time_value': ["10 - 15 minutos", "10 - 15 minutes"],
    'prep_title': ["Necesitarás tener a la mano:", "You'll need to have handy:"],
    'height_weight':['Altura y peso', 'Height & weight'],
    'address': ['Tu direccion (incluido codigo postal)', 'Your address (including your postal code)'],
    'resume': ["Puedes guardar tu progreso y continuar después si lo necesitas.", 
        "You can save your progress and continue later if needed."],
    /*  Step 1 Basics   */
    'basics_title': ['Informacion basica', 'Basic information'],
    'biological_sex': ['Sexo biologico', 'Biological sex'],
    'current_sex': ['Sexo actual', 'Current sex'],
    'birthday': ['Fecha de nacimiento', 'Birth date'],
    'blood_type': ['Tipo de sangre', 'Blood type'],
    'religion': ['Religión', 'Religion'],
    'occupation': ['Ocupación', 'Occupation'],
    'birthplace': ['Lugar de nacimiento', 'Birthplace'],
    'male': ['Hombre', 'Male'],
    'female': ['Mujer', 'Female'],
    'height': ['Altura (cm)', 'Height (cm)'],
    'weight': ['Peso (kg)', 'Weight (kg)'],
    'civil_status': ['Estado civil', 'Civil status'],
    'education': ['Escolaridad', 'Education'],
    'elementary': ['Primaria', 'Primary'],
    'secondary': ['Secundary', 'Secondary'],
    'high_school': ['Preparatoria', 'High school'],
    'professional': ['Profesional', 'Professional'],
    'master': ['Maestria', 'Maestria'],
    'doctorate': ['Doctorado', 'Doctorate'],

    /*  Step 2 Contact info */
    'contact_title': ['Informacion de contacto', 'Contact info'],
    //  Address
    'current_address': ['Residencia actual', 'Current residence'],
    'street': ['Calle', 'Street'],
    'number': ['Numero', 'Number'],
    'interior_number': ['Numero interior', 'Interior number'],
    'state' : ['Estado', 'State'],
    'zip_code': ['Codigo postal', 'ZIP Code'],
    'city': ['Ciudad', 'City'],
    'country': ['Pais', 'Country'],
    'google_maps_url': ['Google Maps URL', 'Google Maps URL'],
    //  Personal phone
    'personal_phones': ['Numeros personales', 'Personal Phones'],
    'add_phone': ['Añadir telefono', 'Add number'],
    //  Emergency contacts
    'emergency_contacts': ['Contactos de emergencia', 'Emergency Contacts'],
    'name': ['Nombre', 'Name'],
    'phone': ['Telefono', 'Phone number'],
    'select_relationship': ['Seleccione relacion', 'Select relationship'],
    
    'add_contact': ['Añadir cotnacto', 'Add contact'],
    
    /*  Step 3 Substance use    */
    'substances_section_title': ['Uso de sustancias', 'Use of substances'],
    //  Alcohol
    'alcohol_consumption': ['Consumo de alcohol', 'Alcohol Consumption'],
    'frequency' : ['Frecuencia', 'Frequency'],
    'quantity' : ['Cantidad', 'Quantity'],
    'motivation': ['Motivacion', 'Motivation'],
    'drinks_per_session': ['Bebidas por sesion', 'Drinks per session'],
    'equivalence_legend' : ['Un trago equivale a una cerveza (355ml), una copa de vino o un shot de destilado.', 
        'One drink equals one beer (12oz), one glass of wine, or a shot of spirit.'],
    //  Smoking
    'smoking': ['Tabaco / Vape / Cannabis', 'Tobacco / Vape / Cannabis'],
    'form': ['Forma', 'Form'],
    'sessions_per_day': ['Sesiones por día', 'sessions per day'], 
    'from_year': ['Desde año', 'From year'],
    'to_year': ['Hasta año', 'To year'],
    'add_habit': ['Añadir habito', 'Add habit'],
    //  Other subsantces
    'substances_use': ['Uso de substancias', 'History of substance use?'],
    'substances_details': ['', 'Additional Details / Substance Types'],
    'substances_placeholder': ['Por favor especificar: Cocaina, LSD...', 'Please specify: Cocaine, LSD...'],
    'add_substance': ['Añadir substancia', 'Add substance'],
    

    /*  Step 4 General Health   */
    'general_health_section_title': ['Estado general', 'General state'],
    //  Physical activity
    'physical_activity_title': ['Actividad fisica', 'Physical Activity'],
    'days_week': ['Dias a la semana', 'Days a week'],
    //  Diet
    'diet_habits_title': ['Hábitos alimenticios', 'Dietary habits'],
    'meals_day': ['Comidas al día', 'Meals per day'],
    'water_intake': ['Consumo de agua', 'Water intake'],
    'junk_food_freq': ['Comida procesada/chatarra', 'Ultra-processed food freq.'],
    'special_diet': ['¿Sigue alguna dieta especial?', 'Do you follow a special diet?'],
    'select_diet': ['Seleccione su dieta', 'Select your diet'],
    //  Sex
    'sexual_activity_title': ['Actividad sexual', 'Sexual activity'],
    'sexually_active': ['Activo sexualmente', 'Sexually active'],
    'partners_range': ['Compañer@s (ultimo año)', 'Partners (Last Year)'],
    'barrier_method': ['Metodo de barrera (Condon)', 'Barrier method (Condom)'],

    '': ['', ''],
  }
    